exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1aa663b4] .el-card__body{height:100%}[data-v-1aa663b4] .el-icon-arrow-right{display:none}", ""]);

// exports
